import type { Agency, AgencyNode, AgencyStructureNode } from '@gat-ship/types'

export function mapAgencyNodeToAgency(agencyNode: AgencyNode): Agency {
  return {
    contactInfo: agencyNode.contactInfo,
    id: agencyNode.id,
    isInactive: agencyNode.isInactive,
    level: agencyNode.level,
    linkedCompany: agencyNode.linkedCompany,
    name: agencyNode.name,
    parentGroup: agencyNode.parentGroup,
    shortName: agencyNode.shortName,
    treePath: agencyNode.treePath,
    canChangeContactInfo: agencyNode.canChangeContactInfo,
    canChangeName: agencyNode.canChangeName,
    canDeactivate: agencyNode.canDeactivate,
    canLinkCompany: agencyNode.canLinkCompany,
    canMove: agencyNode.canMove,
    canReactivate: agencyNode.canReactivate
  }
}

export function mapAgencyToAgencyStructureNode(
  agency: Agency
): AgencyStructureNode {
  return { $type: 'agency', ...agency }
}
